/* eslint-disable class-methods-use-this */
import { observable, action, computed } from 'mobx';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';

const userObj = {
  name: null,
  email: null,
  views: null,
  downloads: null,
  lbCredits: null,
  lbCreditsPlan: false,
  currentPlan: null,
  crmPreferences: null,
  emailPreferences: null,
  timeZone: null,
  apiKey: null,
  memberId: null,
  trialUsed: false,
  userLoggedIn: false,
  businessEmail: null,
  paymentPending: false,
  salesgearApiKey: '',
  jobRole: null,
  phone: null,
  trialHubspotData: null,
  conciergeCredits: null,
  secondaryEmail: null,
  secondaryEmailStatus: null,
  emailUpdateHistory: [],
  secondaryEmailUpdateHistory: [],
  source: null,
  isEnterpriseAdmin: false,
  teamCRMPreferences: {},
};

export const salesgearUserObj = {
  apiKey: null,
  email: null,
  emailPreferences: null,
  firstName: null,
  lastName: null,
  memberId: null,
  phone: null,
  role: null,
  status: null,
  title: null,
};

const userLimit = {
  limit: 12,
};

class UserDetail {
  @observable userInfo = { ...userObj, ...userLimit };

  @observable contactSavedSearches = [];

  @observable companySavedSearches = [];

  @observable onFirstLoad = false;

  @observable myLeadList = [];

  @observable myLeadListWithShared = [];

  @observable myLeadListLoaded = false;

  @observable isFreeTrial = false;

  @observable isEnterpriseFreeTrial = false;

  @observable showNotificationType = '';

  @observable featureFlags = {
    ADVANCED_FILTERS: false,
    BULK_ENRICHER: false,
    BULK_VALIDATOR: false,
    COPY_RESTRICTION: false,
    CRM_EXPORT: false,
    CSV_EXPORT: false,
    CUSTOM_PLAN: false,
    EU_CONTACTS: false,
    LEAD_BUILDER: false,
    LINKEDIN_CONNECT: false,
    LINKEDIN_SALES_NAVIGATOR: false,
    LIST_BUILDING: false,
    PHONE_NUMBER: false,
    SEARCH_RESULTS: false,
    SEEKER: false,
    LOCATION_PREFERENCE: true,
    LB_ENGAGE_EXPORT_ENABLED: false,
    COMPANY_KEYWORD_SEARCH: false,
    CONTACT_PER_COMPANY_FILTER: false,
    TECHNOLOGY_FILTER: false,
    COMPANY_CSV_EXPORT: false,
    COMPANY_CRM_EXPORT: false,
    COMPANY_CSV_EXPORT_INTERNAL: false,
    SUPPRESSION_LIST: false,
    CONCIERGE: false,
    INSIDE_STORY: false,
    MOBILE_NUMBER_FILTER: false,
    DIRECT_DIAL_FILTER: false,
    ANY_PHONE_NUMBER_FILTER: false,
    JOB_CHANGES: false,
    CONTACT_UPDATES: true,
    SAVED_SEARCH_UPDATES: false,
    NEW_COMPANY_SUGGESTION: false,
    INDUSTRY_CLASSIFICATION_FILTER: false,
    SHARED_LIST: false,
  };

  @observable isMyLeadEnabled = null;

  @observable advCurrentTab = '';

  @observable salesgearUserInfo = salesgearUserObj;

  @observable hubspotCalendarLink =
    CONSTANTS.EXTERNAL_LINKS.HUBSPOT_DEFAULT_CALENDAR_LINK;

  @observable subscriptionPlans = [];

  @observable currentSubscriptionPlanInfo = null;

  @observable showActivateAccountPage = false;

  @observable showG2Popup = false;

  @observable showUpdateUserEmailPopup = null;

  @observable showPasswordSetupPage = false;

  @observable showUpgradeCreditPopup = false;

  @observable initialLoadedAPIs = {
    contactSavedSearches: false,
  };

  @observable sharedListAuthorData = {};

  // feature flags

  @computed
  get isContactUpdatesEnabled() {
    return false;
    // return this.featureFlags.CONTACT_UPDATES;
  }

  @computed
  get isJobChangesEnabled() {
    return false;
    // return this.featureFlags.JOB_CHANGES;
  }

  // feature flags end

  @action
  updateInitialLoadedAPIs = key => {
    this.initialLoadedAPIs = { ...this.initialLoadedAPIs, [key]: true };
  };

  @action
  setShowUpgradeCreditPopup = value => {
    this.showUpgradeCreditPopup = value;
  };

  @action setMyLeadList = list => {
    this.myLeadList = list;
  };

  @action setMyListsWithShared = list => {
    this.myLeadListWithShared = list;
  };

  @action
  setShowPasswordSetupPage = value => {
    this.showPasswordSetupPage = value;
  };

  @action
  setShowUpdateUserEmailPopup = (value = null) => {
    this.showUpdateUserEmailPopup = value;
  };

  @action
  setShowG2Popup = value => {
    this.showG2Popup = value;
  };

  @action
  setShowActivateAccountPage = val => {
    this.showActivateAccountPage = val;
  };

  @action
  setShowNotificationType = (val = '') => {
    this.showNotificationType = val;
  };

  @action
  setSubscriptionPlans = val => {
    this.subscriptionPlans = val;
  };

  @action
  setCurrentSubscriptionPlanInfo = val => {
    this.currentSubscriptionPlanInfo = val;
  };

  @action
  setCurrentTab(value = '') {
    if (value !== '' && this.advCurrentTab !== value)
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_LEAD_BUILDER_VIEWD, {
        activeTab: value,
      });
    this.advCurrentTab = value;
  }

  @computed
  get hasCustomPlanManage() {
    return this.featureFlags.CUSTOM_PLAN && this.userInfo.role === 'ROLE_ADMIN';
  }

  @action
  setInitialLoad = (val = true) => {
    this.onFirstLoad = val;
  };

  @action
  setIsFreeTrial = (val = false) => {
    this.isFreeTrial = val;
  };

  @action
  setIsEnterpriseFreeTrial = (val = false) => {
    this.isEnterpriseFreeTrial = val;
  };

  @action
  setUserInfo(obj = userObj) {
    this.userInfo = { ...obj, ...userLimit };
  }

  @action
  setIsMyLeadEnbled(val = false) {
    this.isMyLeadEnabled = val;
  }

  @action
  updateUserInfo(obj) {
    this.userInfo = { ...this.userInfo, ...obj };
  }

  @action
  setUserFeatureFlags(obj = null) {
    const tempObj = obj;
    if (tempObj !== null) tempObj.LOCATION_PREFERENCE = true;
    this.featureFlags = tempObj;
  }

  @action
  setSavedSearches(obj = [], searchType = 'contact') {
    if (searchType === 'contact') {
      this.contactSavedSearches = obj;
      if (!this.initialLoadedAPIs.contactSavedSearches)
        this.updateInitialLoadedAPIs('contactSavedSearches');
    } else if (searchType === 'company') {
      this.companySavedSearches = obj;
    }
  }

  @action
  addNewListToMyList = props => {
    const { id, name, count = 0, isSharedList = false } = props;
    if (id && name) {
      const date = new Date();
      const newObj = {
        id,
        name,
        count,
        lastPurchasedDate: null,
        createdDate: date,
        isSharedList,
        memberId: this.userInfo.memberId,
      };
      const tempList = Utils.copyObjectWithoutReference(this.myLeadList);
      tempList.splice(1, 0, newObj);

      this.myLeadList = tempList;
    }
  };

  @action
  updateMyleadsListCount(obj = {}) {
    const myLeads = Utils.copyObjectWithoutReference(this.myLeadList);
    if (myLeads.length > 0) {
      const newMyLeads = myLeads.map(item => {
        if (Object.prototype.hasOwnProperty.call(obj, item.id)) {
          const count = obj[item.id];
          return { ...item, count };
        }
        return item;
      });
      this.myLeadList = newMyLeads;
    }
  }

  @action
  setSalesgearUserInfo = value => {
    this.salesgearUserInfo = { ...this.salesgearUserInfo, ...value };
  };

  @action
  setHubspotCalendarLink(value = null) {
    if (value) this.hubspotCalendarLink = value;
  }
}

const userDetail = new UserDetail();
export { userDetail };
export default userDetail;
